import React from 'react';
import Dropzone from 'dropzone';
import $ from 'jquery';
import { isMobile } from 'react-device-detect';

import { apiUrl } from '../../env';

const dictDefaultMessage = () => {
  if (isMobile) {
    return '<span class="button button-invert files"><i class="fa fa-folder-open"></i> Wählen Sie die Dateien aus</span><div class="margin-bottom-xs">oder</div><span class="button button-invert files no-margin-bottom" style="display: inline-table"><i class="fa fa-camera"></i> Fotografieren Sie Ihre <br /> Dokumente</span>';
  }

  return 'Ziehen Sie Ihre Dateien einfach hier hin oder <br /><span class="button button-invert files"><i class="fa fa-folder-open"></i> Wählen Sie die Dateien aus</span>';
};

const formUploadTexts = {
  dictDefaultMessage: dictDefaultMessage(),
  dictFallbackMessage: 'Wählen Sie hier eine Datei von Ihrem Computer und laden Sie diese hoch:',
  dictFallbackText: 'Bitte nutzen Sie das Fallbackformular zum Hochladen einzelner Dateien.',
  dictFileTooBig: 'Datei zu groß ({{filesize}}MB). Maximale Dateigröße: {{maxFilesize}}MB.',
  dictInvalidFileType: 'Dateien dieses Dateityps werden nicht unterstützt.',
  dictResponseError: 'Server antwortete mit Statuscode: {{statusCode}}',
  dictCancelUpload: 'Abbruch',
  dictCancelUploadConfirmation: 'Sind Sie sicher, dass Sie den Vorgang abbrechen möchten?',
  dictRemoveFile: 'entfernen',
  dictRemoveFileConfirmation: null,
  dictMaxFilesExceeded: 'Sie können keine weiteren Dateien hochladen.'
};

const removeUpload = (uploadId, formBaseForId) => {
  $.ajax({
    type: 'DELETE',
    url: `${apiUrl(location.hostname)}/api/forms/upload/${uploadId}`,
    xhrFields: {
      withCredentials: process.env.NODE_ENV == 'staging'
    },
    success() {
      // remove upload token from hidden input for upload tokens
      const uploadTokensVal = $(`#${formBaseForId} [name="upload_tokens"]`).val();
      let uploadTokens = uploadTokensVal ? uploadTokensVal.split(',') : [];
      uploadTokens = uploadTokens.filter((uploadToken) => uploadId != uploadToken);

      $(`#${formBaseForId} [name="upload_tokens"]`).val(uploadTokens.join());

      $(`#${uploadId}`).closest('.dz-preview').fadeOut(400);
      $(`[data-id="${uploadId}"]`).parent().remove();
    }
  });
};

const addUploadedFileToMainForm = ($fileElement, fileID, formBaseForId) => {
  var fileName = $fileElement.find('.dz-filename').text();

  var fileResult = '<div class="clearfix">';
  fileResult += '<i class="fa fa-file-o"></i>';
  fileResult += '<div class="file-name" title="' + fileName + '">' + fileName + '</div>';
  fileResult += '<i class="fa fa-times-circle remove-upload" data-id="' + fileID + '"></i>';
  fileResult += '</div>';

  $(`#${formBaseForId} .form-uploads`).append(fileResult);

  $('.remove-upload')
    .off('click')
    .click(function () {
      removeUpload($(this).data('id'), formBaseForId);
    });
};

class UploadForm extends React.PureComponent {
  componentDidMount() {
    this.initFileUpload();

    $('.button.close-upload').click(function () {
      if (!$(this).hasClass('disabled')) {
        $('.upload-container, .form-overlay').fadeOut(200);
      }
    });
  }

  initFileUpload() {
    const { formId } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-new_form_upload-${formId}`;
    const formBaseForId = `${contentArticleFormId}-form_bases-${formId}`;

    // settings for german language (TB, GB, MB, KB)
    Dropzone.prototype.filesize = function (size) {
      let string;
      if (size >= (1024 * 1024 * 1024 * 1024) / 10) {
        size = size / ((1024 * 1024 * 1024 * 1024) / 10);
        string = 'TB';
      } else if (size >= (1024 * 1024 * 1024) / 10) {
        size = size / ((1024 * 1024 * 1024) / 10);
        string = 'GB';
      } else if (size >= (1024 * 1024) / 10) {
        size = size / ((1024 * 1024) / 10);
        string = 'MB';
      } else if (size >= 1024 / 10) {
        size = size / (1024 / 10);
        string = 'KB';
      } else {
        size = size * 10;
        string = 'b';
      }
      return '<strong>' + Math.round(size) / 10 + '</strong> ' + string;
    };

    $(`#${forId}`).dropzone({
      maxFilesize: 100, // restrict file size to a maximum 100 MB
      maxFiles: 100, // restrict max files to 100
      timeout: 300000, // increase from default 30000 (30s) to 300000 (5min)
      paramName: 'form_upload[upload]', // changed the param to one accepted by our rails app
      addRemoveLinks: true, // show remove links on each image upload
      thumbnailWidth: 68,
      thumbnailHeight: 68,
      dictDefaultMessage: formUploadTexts.dictDefaultMessage,
      dictFallbackMessage: formUploadTexts.dictFallbackMessage,
      dictFallbackText: formUploadTexts.dictFallbackText,
      dictFileTooBig: formUploadTexts.dictFileTooBig,
      dictInvalidFileType: formUploadTexts.dictInvalidFileType,
      dictResponseError: formUploadTexts.dictResponseError,
      dictCancelUpload: formUploadTexts.dictCancelUpload,
      dictCancelUploadConfirmation: formUploadTexts.dictCancelUploadConfirmation,
      dictRemoveFile: formUploadTexts.dictRemoveFile,
      dictRemoveFileConfirmation: formUploadTexts.dictRemoveFileConfirmation,
      dictMaxFilesExceeded: formUploadTexts.dictMaxFilesExceeded,
      success(file, response) {
        // find the remove button link of the uploaded file and give it an id
        // based of the fileID response from the server
        $(file.previewTemplate).find('.dz-remove').attr('id', response.fileID);

        // add the dz-success class (the green tick sign)
        $(file.previewElement).addClass('dz-success');

        // add upload token to hidden input for upload tokens
        const uploadTokensVal = $(`#${formBaseForId} [name="upload_tokens"]`).val();
        const uploadTokens = uploadTokensVal ? uploadTokensVal.split(',') : [];
        uploadTokens.push(response.fileID);

        $(`#${formBaseForId} [name="upload_tokens"]`).val(uploadTokens.join());

        addUploadedFileToMainForm($(file.previewTemplate), response.fileID, formBaseForId);
      },
      processing(file) {
        if (file.previewElement) {
          $('.button.close-upload').addClass('disabled');

          file.previewElement.classList.add('dz-processing');
          if (file._removeLink) {
            return (file._removeLink.textContent = this.options.dictCancelUpload);
          }
        }
      },
      uploadprogress(file, progress) {
        var node, _i, _len, _ref, _results;

        if (file.previewElement) {
          $('.button.close-upload').addClass('disabled');

          _ref = file.previewElement.querySelectorAll('[data-dz-uploadprogress]');
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push((node.value = progress));
            } else {
              _results.push((node.style.width = '' + progress + '%'));
            }
          }
          return _results;
        }
      },
      complete(file) {
        // if the upload was successful or erroneous
        if (file._removeLink) {
          $('.button.close-upload').removeClass('disabled');

          return (file._removeLink.textContent = this.options.dictRemoveFile);
        }
      },
      removedfile(file) {
        // when the remove button is clicked
        // grap the id of the uploaded file we set earlier
        var uploadId = $(file.previewTemplate).find('.dz-remove').attr('id');

        if (uploadId) {
          // make a DELETE ajax request to delete the file
          removeUpload(uploadId, formBaseForId);
        } else {
          // hide the file
          $(file.previewTemplate).fadeOut(400);
        }
      }
    });
  }

  render() {
    const { formId } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-new_form_upload-${formId}`;

    return (
      <div>
        <div className="upload-container clearfix" style={{ display: 'none' }}>
          <h4>Bitte laden Sie hier Ihre Dokumente hoch:</h4>

          <form
            id={forId}
            className="dropzone"
            encType="multipart/form-data"
            action={`${apiUrl(location.hostname)}/api/forms/upload`}
            acceptCharset="UTF-8"
            method="post"
          >
            <input name="utf8" type="hidden" value="✓" />
            <input type="hidden" value={Date.now()} name="authenticity_token" />

            <div className="fallback">
              <p>
                Sehr geehrte Nutzerin, sehr geehrter Nutzer, der von Ihnen verwendete Webbrowser
                unterstützt das Hochladen von Dateien auf dieser Webseite leider nicht.
              </p>
              <p>
                Kein Problem! Sie können uns Ihre Angaben gern per <strong>E-Mail</strong>, per{' '}
                <strong>Fax</strong> oder per <strong>Post</strong> zusenden. Falls Sie Kontoauszüge
                zur Hand haben, können Sie uns diese auch formlos zusenden.
              </p>
              <p>Bitte verwenden Sie folgende Adressen:</p>
              <p>
                <strong>E-Mail</strong>:{' '}
                <a href="mailto:info@quirinprivatbank.de" className="send-upload-mail">
                  info@quirinprivatbank.de
                </a>
                <br />
                <strong>Tel.</strong>: 0800 0804010
                <br />
                <strong>Fax</strong>: 030 89021-301
                <br />
                <strong>Post</strong>: Kurfürstendamm 119, 10711 Berlin
              </p>
            </div>
          </form>

          <button className="button button-invert close-upload">
            <i className="fa fa-chevron-circle-left" /> zurück zum Formular
          </button>
        </div>
        <div className="form-overlay" />
      </div>
    );
  }
}

UploadForm.propTypes = {
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number
};

export default UploadForm;



// WEBPACK FOOTER //
// ./components/forms/UploadForm.js